<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click="closeRecipientsSelect">
        <div class="head">
          <h3 class="title poll-create__title">{{ `${state.updatedId ? 'Редактировать' : 'Создать'} опрос` }}</h3>
          <div class="close" @click.stop="closeModal">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
              <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
        </div>
        <div class="info">
          <div v-if="hasAnswers"
               class="poll-create__update-error mb-20">
            Нельзя редактировать опрос, который уже находится в процессе голосования!
          </div>
          <div class="info__item mb-20">
            <AppTextarea title="Описание:"
                         :value="state.description"
                         flat
                         :disabled="hasAnswers"
                         input-height="110px"
                         @value-changed="setDescription"
            />
          </div>
          <div class="info__item">
            <AppTextarea title="Вопрос:"
                         :value="state.question"
                         :valid="state.validation.name"
                         flat
                         :disabled="hasAnswers"
                         input-height="70px"
                         @got-focus="clearValidation('name')"
                         @value-changed="setQuestion"
            />
          </div>
        </div>
        <div class="body">
          <div class="members mb-40">
            <p class="members__title">Участники:</p>
            <AppMessageRecipients :is-active="state.recipients.active"
                                  :state="state.recipients"
                                  :disabled="hasAnswers"
                                  width="100%"
                                  @setUserSearch="setUserRecipientSearch"
                                  @toggle-check-recipient="toggleRecipient"
                                  @toggle="toggleRecipientsSelect"
                                  @close="closeRecipientsSelect"
            />
          </div>
          <div class="body__row mb-40">
            <div class="page__item">
              <AppCheckbox title="Открытый опрос"
                           :checked="state.isOpen"
                           :disabled="hasAnswers"
                           @toggle-check="toggleOpen"
              />
            </div>
            <div class="page__item">
              <AppCheckbox title="Несколько вариантов ответа"
                           :checked="state.isMultiple"
                           :disabled="hasAnswers"
                           @toggle-check="toggleMultiple"
              />
            </div>
          </div>
          <div class="answers mb-60">
            <p class="answers__title">Варианты ответа:</p>
            <div class="answers__list mb-40">
              <transition name="fade">
                <div v-if="state.optionsError"
                     class="answers__list-error">
                  {{ state.optionsError }}
                </div>
              </transition>
              <div class="answers__list-item"
                   v-for="(option, index) in state.options"
                   :key="option.id">
                <AppInput :value="option.name"
                          :placeholder="`Вариант ${index + 1}`"
                          :disabled="hasAnswers"
                          width="100%"
                          @got-focus="clearOptionsError"
                          @value-changed="value => setAnswerText({ id: option.id, index }, value)"
                />
                <div v-show="!hasAnswers && index !== 0 && index !== 1"
                     class="answers__list-remove">
                  <AppButtonSmRemove @click.native="removeAnswer({ id: option.id, index })"/>
                </div>
              </div>
            </div>
            <div v-if="!hasAnswers" class="answers__button">
              <AppButtonSmAdd title="Добавить вариант"
                              @click.native="addAnswer"
              />
            </div>
          </div>
          <div class="modal__button-wrap">
            <div class="modal__button">
              <AppButton title="Сохранить"
                         type="third"
                         :disabled="state.isLoading || hasAnswers"
                         @click.native="savePoll"/>
            </div>
            <div class="modal__button">
              <AppButton title="Отмена"
                         type="alt"
                         :disabled="state.isLoading"
                         @click.native="clearAndCloseModal"/>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppInput from '@/components/page/input/AppInput'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppMessageRecipients from '@/components/page/input/AppMessageRecipients'

export default {
  name: 'PollModal',
  components: {
    AppMessageRecipients,
    AppButtonSmRemove,
    AppButtonSmAdd,
    AppInput,
    AppCheckbox,
    AppTextarea,
    AppButton
  },
  props: {},
  computed: {
    state () {
      return this.$store.getters.getFeedPollModal
    },
    hasAnswers () {
      return this.state?.answers && this.state.answers.length !== 0
    }
  },
  methods: {
    savePoll () {
      this.$store.dispatch('[feed-poll] saveInfo')
    },
    closeModal () {
      this.$store.commit('[feed-poll] CLOSE_MODAL')
      this.$store.commit('[feed-poll] CLOSE_RECIPIENTS')

      if (this.state.updatedId) {
        this.$store.commit('[feed-poll] CLEAR_MODAL')
      }
    },
    clearAndCloseModal () {
      this.$store.commit('[feed-poll] CLOSE_MODAL')
      this.$store.commit('[feed-poll] CLEAR_MODAL')
    },
    setDescription (value) {
      this.$store.commit('[feed-poll] SET_DESCRIPTION', value)
    },
    setQuestion (value) {
      this.$store.commit('[feed-poll] SET_QUESTION', value)
    },
    setUserRecipientSearch (value) {
      this.$store.dispatch('[feed-poll] setUserRecipientSearch', value)
    },
    toggleRecipient (recipient) {
      this.$store.commit('[feed-poll] TOGGLE_SELECTED_RECIPIENT', recipient)
    },
    toggleRecipientsSelect () {
      this.$store.commit('[feed-poll] TOGGLE_RECIPIENTS')
    },
    closeRecipientsSelect () {
      this.$store.commit('[feed-poll] CLOSE_RECIPIENTS')
    },
    toggleOpen () {
      this.$store.commit('[feed-poll] TOGGLE_OPEN')
    },
    toggleMultiple () {
      this.$store.commit('[feed-poll] TOGGLE_MULTIPLE')
    },
    addAnswer () {
      this.$store.commit('[feed-poll] ADD_ANSWER')
    },
    removeAnswer (payload) {
      this.$store.commit('[feed-poll] REMOVE_ANSWER', payload)
    },
    setAnswerText (payload, value) {
      const data = {
        payload,
        value
      }
      this.$store.commit('[feed-poll] SET_ANSWER_TEXT', data)
    },
    clearOptionsError () {
      this.$store.commit('[feed-poll] CLEAR_OPTIONS_ERROR')
    },
    clearValidation (inputName) {
      this.$store.commit('[feed-poll] CLEAR_VALIDATION', inputName)
    }
  },
  mounted () {
    this.$store.dispatch('[feed-poll] getRecipientUserOptions')
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  overflow: auto;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;
}

.modal {
  max-width: 912px;
  align-items: stretch;

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.head {
  display: flex;
  flex-flow: row nowrap;
  padding: 30px 30px 22px 34px;
}

.close {
  margin-left: auto;
  color: $color_third-dark;
  cursor: pointer;
  padding-right: 10px;

  &:hover {
    color: $color_second-light;
  }
}

.title {
  font-weight: bold;
  color: $font_color_third;
  font-size: 18px;
  margin-bottom: 20px;
}

.subtitle {
  font-weight: bold;
  margin-bottom: 20px;
}

.poll-create {
  &__title {
    margin-bottom: 0;
  }

  &__update-error {
    color: $color_error;
    font-size: 1.1em;
  }

  &__name {
    margin-bottom: 40px;
  }
}

.info {
  background: $color_sixth;
  padding: 36px 40px 40px 32px;
}

.body {
  padding: 40px 40px 50px;

  &__row {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 20px;
  }
}

.members {
  &__title {
    color: $font_color_second;
    display: block;
    margin-bottom: 10px;
  }
}

.answers {
  &__title {
    color: $font_color_second;
    display: block;
    margin-bottom: 10px;
  }

  &__list {
    &-error {
      margin-bottom: 10px;
      color: $color_error;
      font-size: 0.8em;
    }

    &-item {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &-remove {
      flex-shrink: 0;
      margin-left: 10px;
    }
  }

  &__button {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
